import { ForwardedRef, forwardRef } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { DateInput, DateInputProps } from "../forms/date-input";
import { FormField, TFormField } from "./form-field";

export type DateInputFormField<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = TFormField<TFieldValues, TFieldPath> & Pick<DateInputProps, "readOnly">;

export const DateInputFormField = forwardRef(function DateInputFormField<
  TFieldValues extends FieldValues = FieldValues,
  TFieldPath extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: DateInputFormField<TFieldValues, TFieldPath>,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <FormField {...props}>
      {(field) => (
        <DateInput
          ref={ref}
          {...field}
          required={props.required}
          onChange={(value) => field.onChange({ target: { value } })}
        />
      )}
    </FormField>
  );
});
